import StaffOTPLogin from './pensionDetails';

function App() {
  return (
    <div style={{ padding: 20 }}>
      <StaffOTPLogin />
    </div>
  );
}

export default App;
